import managerHeaderWeekUrl from './managerHeaderWeek.html';
import employeeHeaderWeekUrl from './employeeHeaderWeek.html';

class CalendarHeaderWeekCtrl {
  constructor(ShiftHeaderUtils, ShiftUtils, dateFilter) {
    'ngInject';

    Object.assign(this, { ShiftHeaderUtils, ShiftUtils, dateFilter });
  }

  $onInit() {
    this.templateUrl = this.forManager ? managerHeaderWeekUrl : employeeHeaderWeekUrl;
    this.todayString = this.dateFilter(this.ShiftHeaderUtils.getCurrentDate(), 'yyyy-MM-dd');
  }
}

export default {
  template: '<ng-include src="ctrl.templateUrl" />',
  controller: CalendarHeaderWeekCtrl,
  controllerAs: 'ctrl',
  bindings: {
    currentDays: '<',
    processingMode: '<',
    notes: '<',
    goToDay: '&',
    openNotesModal: '&',
    forManager: '<',
  },
};
